export default "__VITE_ASSET__dfdfadb6__"